import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import customColors from 'src/config/colorsV2'
import { forPhoneOnly, forTabletPortraitUp } from 'src/config/mediaQueries'
import { TRANSITION_TIME_IN_SECONDS } from '@context/AppointmentCalendarContext/AppointmentCalendarContext'
import { Theme } from '@mui/material/styles'

const SLOT_HEIGHT = 44

export const COMPACT_SLOTS_STYLES = {
  width: '96px',
  [forPhoneOnly]: {
    width: '62px',
  },
}

export type SlotsUseStylesProps = {
  variant?: 'default' | 'compact'
}

export default createUseStyles<string, SlotsUseStylesProps, Theme>(
  (theme: Theme) => ({
    root: {
      display: 'flex',
      gap: 8,
      justifyContent: ({ variant }) => (variant === 'compact' ? 'center' : 'space-between'),
      margin: [0, 16, 24],
      transition: `left ${TRANSITION_TIME_IN_SECONDS}s ease-in-out, right ${TRANSITION_TIME_IN_SECONDS}s ease-in-out`,
      visibility: 'visible',
      position: 'relative',
      right: '0%',
      left: '0%',

      [forTabletPortraitUp]: {
        gap: 16,
        margin: [0, 0, 32],
      },
    },
    transitionRight: {
      left: 'unset',
    },
    transitionLeft: {
      right: 'unset',
    },
    isTransitioning: {
      visibility: 'hidden',
    },
    isTransitioningToLeft: {
      right: '100%',
    },
    isTransitioningToRight: {
      left: '100%',
    },

    dayColumn: ({ variant }) => (variant === 'compact' ? { ...COMPACT_SLOTS_STYLES } : { width: '100%' }),

    slots: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      gap: 8,
      [forTabletPortraitUp]: {
        gap: 16,
      },
    },

    slot: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
      height: SLOT_HEIGHT,
      border: [1, 'solid', theme.palette.primary.main],
      borderRadius: 4,
      cursor: 'pointer',
      fontFamily: 'Roboto',
      fontSize: 14,
      fontWeight: 500,
      userSelect: 'none',
      color: theme.palette.primary.main,
      boxShadow: '0px 1px 2px rgba(33, 33, 33, 0.1)',
      backgroundColor: customColors.white,

      '&$selected': {
        backgroundColor: theme.palette.highlight2['800'],
        color: customColors.white,
      },
    },

    empty: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
      height: SLOT_HEIGHT,

      '&:before': {
        content: '""',
        width: 18,
        height: 2,
        backgroundColor: customColors.gainsboro,
      },
    },

    selected: {},
    toggleMoreAppointments: {
      ...typography['Lato Link 2'],
      cursor: 'pointer',
      color: theme.palette.primary[800],
      padding: [0, 16, 24, 0],
      [forPhoneOnly]: {
        paddingLeft: 16,
      },
    },
  }),
  { name: 'Slots' }
)
